

export default class ImportBackend {
	static type = "backend";

	async read(language, namespace, callback) {
		try {
			// import(`...`) will trigger a bug in eslint
			/* webpackChunkName: "translations" */
			/* webpackMode: "lazy" */
			const value = await import('locales/' + language + '/' + namespace + '.json');
			callback(null, value);
		} catch (err) {
			callback(err, null);
		}
	}
}
